<div #mobileOffcanvas class="offcanvas offcanvas-bottom" tabindex="-1" [id]="content?.id"
    [attr.aria-labelledby]="(content?.id ||'offcanvas')+'Label'">
    <div class="offcanvas-header header-sec">
        <div class="heading">Your cover & benefits</div>
        <button type="button" id="" name="" class="btn-close text-reset pt-2" (click)="closeOffcanvas()"></button>
    </div>
    <div class="offcanvas-body">
        <div class="block-sec">
            <div class="head text-start">Your policy benefits</div>
            <div class="divider_yellow"></div>
              <ul>
                <li>The Policy insures you against the <span class="font-weight-bold">risk of death, permanent
                        disability and critical illness.</span>
                </li>
                <div class="border-li"></div>
                <li>If we approve your claim, we will pay out the
                    <span class="font-weight-bold">Insured Sum in a lump sum</span> to you, your estate or your
                    beneficiary.
                </li>
                <div class="border-li"></div>
                <li>Your Policy ends on the earlier of the <span class="font-weight-bold">conclusion of your debt review
                        or your death.</span>
                </li>
            </ul>
        </div>
        <div class="block-sec">
            <div class="head text-start">Your cover</div>
            <div class="divider_yellow"></div>
            <ul class="policy-list">
                <li>Death: <span class="font-weight-bold">R {{PolicyDetailResponse?.insuredSum || 0 | number:'1.0-2'}}</span>
                </li>

                <li>Permanent Disability: <span class="font-weight-bold">R {{PolicyDetailResponse?.permanentDisabilityCoverAmt || 0 | number:'1.0-2'}}</span>
                </li>

                <li>Critical Illness: <span class="font-weight-bold">R {{PolicyDetailResponse?.criticalIllnessCoverAmt || 0 | number:'1.0-2'}}</span>
                </li>
            </ul>
        </div>
        <div class="block-sec">
            <div class="head text-start">Limitations & exclusions</div>
            <div class="divider_yellow"></div>
              <ul>
                <li>Age Limitations: Beneficiaries cannot be below the age of <span class="font-weight-bold">18.</span>
                </li>
                <div class="border-li"></div>
                <li>Accelerated Benefits: The permanent disability and critical illness benefits are accelerated
                    benefits, which means that
                    the <span class="font-weight-bold">amount we pay out for a successful claim will be deducted from
                        the amount we pay out under the death benefit.
                    </span>
                </li>
                <div class="border-li"></div>
                <li>Termination of Benefits: <span class="font-weight-bold">All </span>your benefits end when you
                    turn <span class="font-weight-bold">65.</span>
                </li>
                <div class="border-li"></div>
                <li>Waiting Periods: Your benefits are subject to a <span class="font-weight-bold">6 month</span>
                    waiting period on all claims <span class="font-weight-bold">except for accidental death</span> and
                    <span class="font-weight-bold">injuries leading to disability.</span>
                </li>
                <div class="border-li"></div>
                <li>Deferred Periods: If you make a claim under the <span class="font-weight-bold">permanent disability
                        benefit,</span> a
                    <span class="font-weight-bold"> 6 month deferred period </span>will be applied
                    to determine if the disability is permanent.
                </li>
                <div class="border-li"></div>
                <li>Exclusions: We will not pay a claim if the claim event is
                    <ul>
                        <li>
                            <span class="font-weight-bold">For death, disability or illness:</span>
                            Caused by self-harm, criminal acts, unscheduled flights, war, dangerous activities, alcohol
                            or drugs or by not following prescribed medical treatment.
                        </li>
                        <li>
                            <span class="font-weight-bold">For a period of 12 months from the start of the
                                Policy:</span>
                            Caused by a medical condition for which you
                            received medical treatment 12 months before you entered into the Policy (for Disability and
                            Critical Illness) or if you
                            committed suicide within 24 months of the policy start date (Death). This period will be
                            reduced if you
                            have already
                            served such exclusion periods under any policies replaced by this Policy.
                        </li>
                    </ul>

                </li>
            </ul>
        </div>
        <div class="block-sec-footer">
            Individually issued policy document T&C's take precedence over the generalised information provided in your
            insurance
            summary.
        </div>
    </div>
</div>